(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8108],{

/***/ 41469:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]",
      function () {
        return __webpack_require__(72562);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ UserPublicProfile; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./modules/UserProfile/hooks.ts
var hooks = __webpack_require__(26136);
// EXTERNAL MODULE: ../ui/src/components/Loading/Loading.tsx
var Loading = __webpack_require__(69193);
// EXTERNAL MODULE: ./modules/UserProfile/Wrappers/UserPageWrapper.tsx
var UserPageWrapper = __webpack_require__(4976);
// EXTERNAL MODULE: ./modules/UserProfile/Wrappers/UserPageContentWrapper.tsx
var UserPageContentWrapper = __webpack_require__(62649);
// EXTERNAL MODULE: ./modules/UserProfile/Wrappers/UserSubpageWrapper.tsx
var UserSubpageWrapper = __webpack_require__(93540);
// EXTERNAL MODULE: ./modules/UserProfile/ProfileCover/ProfileCover.tsx
var ProfileCover = __webpack_require__(7247);
// EXTERNAL MODULE: ./modules/User/SubscribeButton/SubscribeButton.tsx + 1 modules
var SubscribeButton = __webpack_require__(48102);
// EXTERNAL MODULE: ./modules/UserProfile/ProfileAvatar/ProfileAvatar.tsx
var ProfileAvatar = __webpack_require__(11676);
// EXTERNAL MODULE: ./modules/UserProfile/UserInfo/ActionsRow.tsx
var ActionsRow = __webpack_require__(59070);
// EXTERNAL MODULE: ./modules/UserProfile/UserInfo/UserInfoContent.tsx + 2 modules
var UserInfoContent = __webpack_require__(21882);
// EXTERNAL MODULE: ../ui/src/components/Button/Button.tsx
var Button = __webpack_require__(57100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./modules/UserProfile/UserInfo/UserPublicInfo.tsx








const UserPublicInfo = (param)=>{
    let { user  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative p-4 bg-white rounded-2xl w-full max-w-[1126px] mx-auto mb-10 md:mb-7 md:flex md:items-center md:gap-6 md:px-6 md:py-8 lg:gap-10 lg:mb-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-1/2 -translate-x-1/2 -top-[85px] w-fit md:static md:translate-x-0 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* ProfileAvatar */.S, {
                    src: user.avatar_key
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " w-full grid mt-[80px] md:mt-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto md:absolute md:top-6 md:right-6 lg:top-8 lg:right-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsRow/* ActionsRow */.G, {
                            user: user
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoContent/* UserInfoContent */.V, {
                        user: user,
                        subscribeButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeButton/* SubscribeButton */.T, {
                            button: (param)=>/*#__PURE__*/ {
                                let { subscribe , isSubscribed , isLoading  } = param;
                                return (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                    disabled: isLoading,
                                    variant: isSubscribed ? "base" : "outline",
                                    onClick: ()=>subscribe(user.cognito_id),
                                    className: classnames_default()({
                                        "bg-neutral-100": isSubscribed
                                    }, "!drop-shadow h-[40px] flex items-center !px-4 text-[14px]"),
                                    children: isSubscribed ? "Subscribed" : "Subscribe"
                                });
                            },
                            isSubscribed: user.isSubscribed,
                            accountId: user.cognito_id,
                            className: "!drop-shadow h-[40px] flex items-center !px-4 text-[14px]"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/UserProfile/MainTabs/MainTabs.tsx
var MainTabs = __webpack_require__(9382);
// EXTERNAL MODULE: ./modules/Video/VideoModalContext.tsx
var VideoModalContext = __webpack_require__(35715);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-seo@5.8.0_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(98334);
// EXTERNAL MODULE: ./utils/useResolveAwsImgPath.ts
var useResolveAwsImgPath = __webpack_require__(32554);
// EXTERNAL MODULE: ./modules/Config/ConfigContext.tsx
var ConfigContext = __webpack_require__(65729);
;// CONCATENATED MODULE: ./modules/UserProfile/UserPublicProfileSeo.tsx





const UserPublicProfileSeo = (param)=>{
    let { user  } = param;
    const { pageUrl  } = (0,ConfigContext/* useConfig */.ZR)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: user.name,
        defaultTitle: user.name,
        titleTemplate: user.name,
        description: user.description || undefined,
        openGraph: {
            url: "".concat(pageUrl, "/users/").concat(user.cognito_id),
            ...user.avatar_url ? {
                images: [
                    {
                        url: (0,useResolveAwsImgPath/* useResolveAwsImgPath */.u)(user.avatar_url),
                        width: 601,
                        height: 601,
                        secureUrl: (0,useResolveAwsImgPath/* useResolveAwsImgPath */.u)(user.avatar_url),
                        alt: user.name
                    }
                ]
            } : undefined
        }
    });
};

// EXTERNAL MODULE: ./utils/useButtonsAnalytics.tsx
var useButtonsAnalytics = __webpack_require__(76356);
;// CONCATENATED MODULE: ./modules/UserProfile/UserPublicProfile.tsx











const UserPublicProfile = (param)=>{
    let { children , id  } = param;
    (0,useButtonsAnalytics/* useButtonsAnalytics */.V)();
    const { useUserProfileQuery , useUserResourceCountQuery  } = (0,hooks/* useUserProfile */.Gr)();
    const { data: userProfile , isLoading  } = useUserProfileQuery(id);
    const { data: resourceCount  } = useUserResourceCountQuery(id);
    if (!userProfile || isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoModalContext/* VideoModalProvider */.ke, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPublicProfileSeo, {
                user: userProfile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserPageWrapper/* UserPageWrapper */.d, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileCover/* ProfileCover */.D, {
                        src: userProfile.background_key
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserPageContentWrapper/* UserPageContentWrapper */.L, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPublicInfo, {
                                user: userProfile
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserSubpageWrapper/* UserSubpageWrapper */.X, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTabs/* MainTabs */.E, {
                                        links: [
                                            {
                                                href: "/users/".concat(id, "/#nav-scroll"),
                                                match: "/users/[id]",
                                                text: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTabs/* LinkCounter */._, {
                                                    name: "My Videos",
                                                    counter: resourceCount && resourceCount.videosCount
                                                })
                                            },
                                            {
                                                href: "/users/".concat(id, "/parks/#nav-scroll"),
                                                match: "/users/[id]/parks",
                                                text: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTabs/* LinkCounter */._, {
                                                    name: "My Parks",
                                                    counter: resourceCount && "".concat(resourceCount.unlockedStickersCount, "/").concat(resourceCount.parksWithStickersCount)
                                                })
                                            }
                                        ]
                                    }),
                                    typeof children === "function" ? children(userProfile) : children
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ UserVideoListWithPagination; }
});

// UNUSED EXPORTS: UserVideoList

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../contracts/src/media/video-status.enum.ts
var video_status_enum = __webpack_require__(97050);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./modules/Video/VideoCard/VideoCardWithTags.tsx
var VideoCardWithTags = __webpack_require__(95157);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/link.js
var next_link = __webpack_require__(66998);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash.isequal@4.5.0/node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(17361);
var lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(lodash_isequal);
// EXTERNAL MODULE: ./modules/Video/ShareVideo.tsx + 1 modules
var ShareVideo = __webpack_require__(55754);
// EXTERNAL MODULE: ./modules/UserProfile/hooks.ts
var hooks = __webpack_require__(26136);
// EXTERNAL MODULE: ./modules/Toast/Toast.tsx + 3 modules
var Toast = __webpack_require__(39890);
// EXTERNAL MODULE: ./modules/Auth/AuthContext.tsx
var AuthContext = __webpack_require__(35836);
// EXTERNAL MODULE: ../ui/src/components/Modal/confirm.tsx
var Modal_confirm = __webpack_require__(42595);
// EXTERNAL MODULE: ../ui/src/icons/EditIcon/EditOutlineIcon.tsx
var EditOutlineIcon = __webpack_require__(49292);
// EXTERNAL MODULE: ../ui/src/icons/ShareIcon/ShareIcon.tsx
var ShareIcon = __webpack_require__(35368);
// EXTERNAL MODULE: ../ui/src/components/Dropdown/Dropdown.tsx + 4 modules
var Dropdown = __webpack_require__(60507);
;// CONCATENATED MODULE: ../ui/src/icons/MoreIcon/MoreOutlineIcon.tsx


const MoreOutlineIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            width: "24",
            height: "24",
            fill: "white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.0049 7.24512L12.0049 7.25512",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.0049 11.9951L12.0049 12.0051",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.0049 16.7451L12.0049 16.7551",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../ui/src/icons/DeleteIcon/DeleteOutlineIcon.tsx
var DeleteOutlineIcon = __webpack_require__(73855);
;// CONCATENATED MODULE: ./modules/UserProfile/UserVideoList/UserVideoCardDropdown.tsx











const UserVideoCardDropdown = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { data  } = param;
    const shareVideoRef = (0,react.useRef)(null);
    const { useDeleteUserVideoMutationQuery  } = (0,hooks/* useCurrentUserVideos */.s5)();
    const deleteUserVideo = useDeleteUserVideoMutationQuery();
    const deleteVideo = async ()=>{
        try {
            await deleteUserVideo.mutateAsync({
                videoId: data.id
            });
            (0,Toast/* successToast */.Qm)({
                description: "Video has been removed!"
            });
        } catch (err) {
            (0,Toast/* errorToast */.Jc)({
                description: "Ops! Something went wrong"
            });
        }
    };
    const handleDelete = ()=>{
        (0,Modal_confirm/* confirm */.i)({
            onConfirm: deleteVideo,
            title: "Confirmation",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Are you sure you want to delete this video?"
            })
        });
    };
    const waitingForApprovalActions = (0,react.useMemo)(()=>[
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteVideoButton, {
                onClick: handleDelete,
                authorId: data.author.cognito_id
            })
        ], [
        data.status
    ]);
    const draftActions = (0,react.useMemo)(()=>[
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/videos/".concat(data.id),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserDropdownMenuItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOutlineIcon/* EditOutlineIcon */.B, {}),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Edit"
                        })
                    ]
                })
            }),
            ...waitingForApprovalActions
        ], [
        data.status
    ]);
    const publishedActions = (0,react.useMemo)(()=>[
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserDropdownMenuItem, {
                onClick: ()=>{
                    if (shareVideoRef.current) {
                        shareVideoRef.current.click();
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIcon/* ShareIcon */.a, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Share"
                    })
                ]
            }),
            ...waitingForApprovalActions
        ], [
        data.status
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.L, {
                menuItems: data.status === video_status_enum/* VideoStatus.PUBLISHED */.K.PUBLISHED ? publishedActions : data.status === video_status_enum/* VideoStatus.DRAFT */.K.DRAFT ? draftActions : waitingForApprovalActions,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("text-white w-[40px] h-[40px] rounded-full bg-white/25 backdrop-blur-[2px] flex justify-center items-center hover:backdrop-blur-sm"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreOutlineIcon, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareVideo/* ShareVideo */.u, {
                video: data,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: shareVideoRef,
                    className: "hidden",
                    children: "share"
                })
            })
        ]
    });
}, isEqual);
function isEqual(prevProps, nextProps) {
    return lodash_isequal_default()(prevProps, nextProps);
}
const UserDropdownMenuItem = (param)=>{
    let { children , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: onClick,
        className: "w-full flex gap-1 items-center py-2 px-3 text-neutral-500 text-xs hover:bg-neutral-50",
        children: children
    });
};
const DeleteVideoButton = (param)=>{
    let { onClick , authorId  } = param;
    const { useSession  } = (0,AuthContext/* useAuth */.a)();
    const session = useSession();
    if (!session.data || !session.data.user || session.data.user.cognito_id !== authorId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserDropdownMenuItem, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteOutlineIcon/* DeleteOutlineIcon */.q, {}),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Delete"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/UserProfile/UserVideoList/VideoCardWithTagsAndStatus.tsx






const VideoCardWithTagsAndStatus = (param)=>{
    let { data , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCardWithTags/* VideoCardWithTags */.X, {
        data: data,
        ...rest,
        thumbnailClassName: "h-[190px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "absolute top-4 left-5 right-5 flex justify-between items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("bg-white text-neutral-700 py-1 px-2 rounded-full text-xs capitalize", {
                        invisible: data.status === video_status_enum/* VideoStatus.PUBLISHED */.K.PUBLISHED
                    }),
                    children: data.status === video_status_enum/* VideoStatus.WAITING_FOR_APPROVAL */.K.WAITING_FOR_APPROVAL ? "Waiting for approval" : data.status
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: (e)=>e.stopPropagation(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserVideoCardDropdown, {
                        data: data
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./modules/Video/VideoModalContext.tsx
var VideoModalContext = __webpack_require__(35715);
// EXTERNAL MODULE: ../ui/src/components/ItemsList/ItemsList.tsx
var ItemsList = __webpack_require__(14927);
// EXTERNAL MODULE: ../ui/src/components/Pagination/Pagination.tsx
var Pagination = __webpack_require__(4015);
;// CONCATENATED MODULE: ./modules/UserProfile/UserVideoList/UserVideoList.tsx






const UserVideoList = (param)=>{
    let { data  } = param;
    const { setSelectedVideo  } = (0,VideoModalContext/* useVideoModalContext */.sw)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
        className: "w-full py-6 grid gap-4 md:gap-6 md:grid-cols-2 xl:grid-cols-3",
        items: data,
        noItemsMessage: "Videos not found",
        renderItem: (video)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCardWithTagsAndStatus, {
                data: video,
                onClick: video.status === video_status_enum/* VideoStatus.PUBLISHED */.K.PUBLISHED ? (data)=>setSelectedVideo(data) : undefined
            })
    });
};
const UserVideoListWithPagination = (param)=>{
    let { data , pagination , onPageChange  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserVideoList, {
                data: data
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                    pagination: pagination,
                    onPageChange: onPageChange
                })
            })
        ]
    });
};


/***/ }),

/***/ 72562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ./modules/UserProfile/UserPublicProfile.tsx + 2 modules
var UserPublicProfile = __webpack_require__(80960);
// EXTERNAL MODULE: ./modules/Video/VideoModalContext.tsx
var VideoModalContext = __webpack_require__(35715);
// EXTERNAL MODULE: ./modules/Video/VideoModal/VideoModal.tsx + 4 modules
var VideoModal = __webpack_require__(67882);
// EXTERNAL MODULE: ./modules/UserProfile/hooks.ts
var hooks = __webpack_require__(26136);
// EXTERNAL MODULE: ../ui/src/components/Banners/BannerWrapper.tsx
var BannerWrapper = __webpack_require__(74718);
// EXTERNAL MODULE: ../ui/src/components/SimpleImage/index.tsx
var SimpleImage = __webpack_require__(86978);
// EXTERNAL MODULE: ../ui/src/components/IconButton/IconButton.tsx
var IconButton = __webpack_require__(38937);
// EXTERNAL MODULE: ../ui/src/icons/AddIcon/AddIcon.tsx
var AddIcon = __webpack_require__(84176);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/link.js
var next_link = __webpack_require__(66998);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./modules/UserProfile/UserBanner/BeLikeUserBanner.tsx




const BeLikeUserBanner = (param)=>{
    let { userName  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerWrapper/* BannerWrapper */.S, {
        className: "bg-neutral-100",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative w-full h-[200px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                src: "/media/illustrations/GrandCanyon.webp",
                alt: "Grand canyon",
                fill: true,
                className: "object-contain"
            })
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                variant: "h4",
                className: "text-neutral-900 !text-2xl lg:!text-3xl ",
                children: [
                    "Be like ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-primary-500",
                        children: userName
                    }),
                    " and share your travel experiences"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/videos/new",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddIcon/* AddIcon */.d, {}),
                    position: "left",
                    className: "w-full flex justify-center md:w-fit md:h-[48px]",
                    children: "Submit a video"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/UserProfile/UserVideoList/UserVideoList.tsx + 3 modules
var UserVideoList = __webpack_require__(729);
// EXTERNAL MODULE: ./utils/usePagination/usePaginationQuery.ts + 1 modules
var usePaginationQuery = __webpack_require__(61934);
// EXTERNAL MODULE: ./utils/InitialPaginationContext.tsx
var InitialPaginationContext = __webpack_require__(69933);
// EXTERNAL MODULE: ./utils/useScrollTo/useScrollTo.tsx
var useScrollTo = __webpack_require__(77795);
;// CONCATENATED MODULE: ./modules/Pages/UserPublicProfilePage/UserPublicProfileVideosPage.tsx







const UserPublicProfileVideosPage = (param)=>{
    let { query: { id  } , initialPagination  } = param;
    const { useUserVideosQuery  } = (0,hooks/* useUserVideos */.Dp)();
    const { data: videos , pagination  } = (0,usePaginationQuery/* usePaginationQuery */.Z)((paginationParams)=>useUserVideosQuery(id, paginationParams), {
        initialPagination
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPublicProfile/* UserPublicProfile */.A, {
        id: id,
        children: (user)=>!videos || !videos.data || videos.data.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWithoutVideos, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(InitialPaginationContext/* InitialPaginationContext.Provider */.y.Provider, {
                value: {
                    initialPagination
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWithVideos, {
                        videos: videos,
                        pagination: pagination
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 md:mt-10 lg:mt-[72px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BeLikeUserBanner, {
                            userName: user.name
                        })
                    })
                ]
            })
    });
};
const PageWithVideos = (param)=>{
    let { videos , pagination  } = param;
    const { scrollTo  } = (0,useScrollTo/* useScrollTo */.q)({
        id: "user-videos-section"
    });
    const { setSelectedVideo , selectedVideo  } = (0,VideoModalContext/* useVideoModalContext */.sw)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        id: "user-videos-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserVideoList/* UserVideoListWithPagination */.v, {
                data: videos.data,
                onPageChange: scrollTo,
                pagination: pagination
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* VideoModal */.K, {
                isOpen: !!selectedVideo,
                setIsOpen: ()=>setSelectedVideo(null)
            })
        ]
    });
};
const PageWithoutVideos = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
        variant: "h6",
        component: "h2",
        className: "!font-medium text-neutral-900 mb-12 text-center",
        children: "This user has not added any videos yet..."
    });
};

;// CONCATENATED MODULE: ./pages/users/[id]/index.tsx

var __N_SSP = true;
/* harmony default export */ var _id_ = (UserPublicProfileVideosPage);


/***/ }),

/***/ 69933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useInitialPagination; },
/* harmony export */   "y": function() { return /* binding */ InitialPaginationContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const InitialPaginationContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
const useInitialPagination = ()=>{
    const ctx = react__WEBPACK_IMPORTED_MODULE_0__.useContext(InitialPaginationContext);
    if (!ctx) throw new Error("Initial pagination context is empty");
    return ctx;
};


/***/ }),

/***/ 32554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useResolveAwsImgPath; }
/* harmony export */ });
/* harmony import */ var _modules_Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65729);

const useResolveAwsImgPath = (src)=>{
    const { pageUrl  } = (0,_modules_Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__/* .useConfig */ .ZR)();
    return "".concat(pageUrl).concat(src);
};


/***/ }),

/***/ 74718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ BannerWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const BannerWrapper = (param)=>{
    let { children , icon , className , variant ="auto"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-6 flex items-center gap-6 rounded-2xl", {
            "flex-col md:flex-row": variant === "auto",
            "flex-col": variant === "vertical"
        }, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "min-w-full flex justify-center md:min-w-[25%] xl:min-w-[200px]",
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex flex-col items-center text-center gap-6", {
                    "md:items-start md:text-left": variant === "auto"
                }),
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 3177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ ConfirmationModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88044);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57100);





const ConfirmationModal = (param)=>{
    let { contentClassName , onConfirm , onCancel , children , setIsOpen , actionButtons , ...props } = param;
    const handleConfirm = async (e)=>{
        e.preventDefault();
        onConfirm && await onConfirm();
        setIsOpen(false);
    };
    const handleCancel = async (e)=>{
        e.preventDefault();
        onCancel && await onCancel();
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Modal__WEBPACK_IMPORTED_MODULE_3__/* .Modal */ .u, {
        setIsOpen: setIsOpen,
        ...props,
        contentClassName: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[95%] max-w-[400px] rounded-2xl", contentClassName),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                        "mt-8": !props.title
                    }),
                    children: children
                }),
                actionButtons ? actionButtons(onConfirm) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-4 flex justify-end gap-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                            variant: "base",
                            size: "sm",
                            onClick: handleCancel,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                            size: "sm",
                            variant: "danger",
                            onClick: handleConfirm,
                            children: "Delete"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 42595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ confirm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78520);
/* harmony import */ var _ConfirmationModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3177);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);




function confirm(config) {
    let destroyFn = null;
    const container = document.createDocumentFragment();
    const currentConfig = {
        ...config,
        setIsOpen: close,
        isOpen: true
    };
    function render() {
        const root = domRender(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ConfirmationModal__WEBPACK_IMPORTED_MODULE_3__/* .ConfirmationModal */ .c, {
            ...currentConfig
        }), container);
        destroyFn = ()=>root.unmount();
    }
    function close() {
        if (typeof destroyFn === "function") {
            destroyFn();
        }
    }
    render();
}
function domRender(element, container) {
    const root = react_dom_client__WEBPACK_IMPORTED_MODULE_1__.createRoot(container);
    root.render(element);
    return root;
}


/***/ }),

/***/ 73855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ DeleteOutlineIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const DeleteOutlineIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.66699 7.33333V11.3333M9.33366 7.33333V11.3333M2.66699 4.66667H13.3337M12.667 4.66667L12.089 12.7613C12.065 13.0977 11.9145 13.4125 11.6677 13.6424C11.4209 13.8722 11.0962 14 10.759 14H5.24166C4.90442 14 4.5797 13.8722 4.33292 13.6424C4.08613 13.4125 3.9356 13.0977 3.91166 12.7613L3.33366 4.66667H12.667ZM10.0003 4.66667V2.66667C10.0003 2.48986 9.93009 2.32029 9.80506 2.19526C9.68004 2.07024 9.51047 2 9.33366 2H6.66699C6.49018 2 6.32061 2.07024 6.19559 2.19526C6.07056 2.32029 6.00033 2.48986 6.00033 2.66667V4.66667H10.0003Z",
            stroke: "currentColor",
            strokeWidth: "1.43434",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 30326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 42875:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 37342:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 58205:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6774,7004,2411,3740,4713,965,9774,2888,179], function() { return __webpack_exec__(41469); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);